import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCrosshair = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.875 6.375a.75.75 0 0 1-.75-.75v-.319a6.75 6.75 0 0 0-5.846 6.069h.346a.75.75 0 0 1 0 1.5h-.319a6.754 6.754 0 0 0 5.819 5.819v-.319a.75.75 0 0 1 1.5 0v.346a6.75 6.75 0 0 0 6.069-5.846h-.319a.75.75 0 0 1 0-1.5h.346a6.75 6.75 0 0 0-6.096-6.096v.346a.75.75 0 0 1-.75.75m-8.08 6.5a8.25 8.25 0 0 0 7.33 7.33v1.045a.75.75 0 0 0 1.5 0v-1.023a8.25 8.25 0 0 0 7.58-7.352h1.045a.75.75 0 0 0 0-1.5h-1.023a8.25 8.25 0 0 0-7.602-7.602V2.75a.75.75 0 0 0-1.5 0v1.046a8.25 8.25 0 0 0-7.352 7.579H2.75a.75.75 0 0 0 0 1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCrosshair;
